import React from 'react';
import { QuoteIcon } from 'lucide-react';
export const ParticipantTestimonials = () => {
  return <section className="mb-12" data-id="element-308" data-mp="1uajc7p4f99ny">
      <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-309" data-mp="1ubkwmk7bv8ic">
        Wat deelnemers ervaren tijdens het webinar
      </h2>

      <div className="space-y-6" data-id="element-310" data-mp="1zc8jqusfr57a">
        <div className="bg-gray-50 border-l-4 border-green-500 p-5 rounded-r-lg" data-id="element-311" data-mp="249s1i4oce03z">
          <div className="flex items-start gap-4" data-id="element-312" data-mp="28au4mwldqwb8">
            <img src="https://cdn.magicpatterns.com/uploads/fB8Dhs4wiGrDqogWAqXKm6/Scherm_afbeelding_2025-08-15_om_15.51.14.png" alt="Lenneke uit Utrecht" className="w-14 h-14 rounded-full object-cover flex-shrink-0" data-id="element-313" data-mp="28aava49spg8t" />
            <div data-id="element-314" data-mp="2n000cal0e4ed">
              <QuoteIcon className="w-6 h-6 text-green-400 mb-2" data-id="element-315" data-mp="2myf5ejus8jfz" />
              <p className="text-gray-800 leading-relaxed italic mb-3" data-id="element-316" data-mp="2rzcw5ktuylt3">
                "Na 20 minuten begreep ik al waarom onze wandelingen altijd
                chaotisch waren. Luna probeerde me de hele tijd te vertellen dat
                ze zich onveilig voelde, maar ik interpreteerde het als
                koppigheid. Het moment dat ik dat doorhad, veranderde alles."
              </p>
              <p className="text-sm font-semibold text-gray-700" data-id="element-317" data-mp="13q5s6ubu06vq">
                - Lenneke uit Utrecht
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 border-l-4 border-green-500 p-5 rounded-r-lg" data-id="element-318" data-mp="ytywrvh2ads1">
          <div className="flex items-start gap-4" data-id="element-319" data-mp="1wel437zo292u">
            <img src="https://cdn.magicpatterns.com/uploads/pS516JjYb2Jy2Jib3WaRmC/Scherm­afbeelding_2026-04-07_om_17.13.16.png" alt="Thomas uit Antwerpen" className="w-14 h-14 rounded-full object-cover flex-shrink-0" data-id="element-320" data-mp="1rfqffpf0pqat" />
            <div data-id="element-321" data-mp="2f5uf5lp355wj">
              <QuoteIcon className="w-6 h-6 text-green-400 mb-2" data-id="element-322" data-mp="2f6dzta64e8e9" />
              <p className="text-gray-800 leading-relaxed italic mb-3" data-id="element-323" data-mp="2f7p2f6ntxa3s">
                "Mijn vrouw en ik keken elkaar halverwege het webinar aan.
                'Daarom doet hij dat!' zeiden we tegelijk. Plotseling maakten
                alle rare gewoontes van Rex perfect zin."
              </p>
              <p className="text-sm font-semibold text-gray-700" data-id="element-324" data-mp="dihtqjckj48i">
                - Thomas uit Antwerpen
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 border-l-4 border-green-500 p-5 rounded-r-lg" data-id="element-325" data-mp="3papx2xh7waj">
          <div className="flex items-start gap-4" data-id="element-326" data-mp="3lvf970zr9aww">
            <img src="https://cdn.magicpatterns.com/uploads/cq9sJtJYFgjvYc8NrDV2AV/Scherm­afbeelding_2026-04-07_om_17.14.25.png" alt="Sandra uit Amsterdam" className="w-14 h-14 rounded-full object-cover flex-shrink-0" data-id="element-327" data-mp="3lyupg7560pzw" />
            <div data-id="element-328" data-mp="3gxnj8cio7yvc">
              <QuoteIcon className="w-6 h-6 text-green-400 mb-2" data-id="element-329" data-mp="3gz8e638wdjtq" />
              <p className="text-gray-800 leading-relaxed italic mb-3" data-id="element-330" data-mp="1a7h361ow2c2a">
                "Het was emotioneel. Ik realiseerde me dat Buddy mij al maanden
                probeerde iets te vertellen over zijn angst, en ik dacht maar
                dat hij ongehoorzaam was. Ik voelde me schuldig, maar ook
                opgelucht. Eindelijk begreep ik hem."
              </p>
              <p className="text-sm font-semibold text-gray-700" data-id="element-331" data-mp="39e4mz4kf294t">
                - Sandra uit Amsterdam
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};